import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/form', {
    params: toQuery(params),
  });
}

export async function queryEditItemForm({ id, params }) {
  return request(`/form/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewForm(params) {
  return request.post('/form', {
    data: params,
  });
}

export async function queryAddEditForm(params) {
  return request.put('/form', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/form/${id}`, {});
}

export async function queryFormActivate(params) {
  return request.post(`/form/activate/${params}`, {});
}

export async function queryListPermissions(payload) {
  return request(`/${payload.route}`, {
    params: toQuery(payload.params),
  });
}

export async function querySavePermission(payload) {
  return request.post(`/form/updatePermissions/${payload.id}`, {
    data: payload.data,
  });
}
